// Keep this Node/browser shared CommonJS module free of Babel-injected ES imports.
// Object.assign/slice avoid the object/spread runtime helpers in the CRA build.
// Preserve authored rule settings while accepting both existing Studio and
// runtime field names. Canonical fields win when an author updates them.
function canonicalizeValidationRule(rule) {
  const next = Object.assign({}, rule);
  const type = next.type || next.kind;
  if (type === 'atLeastOne' && !Array.isArray(next.fields) && Array.isArray(next.keys)) {
    next.fields = next.keys.slice();
  }
  if (type === 'compare' && next.compare && typeof next.compare === 'object') {
    for (const key of ['left', 'op', 'right']) {
      if (next[key] === undefined && next.compare[key] !== undefined) next[key] = next.compare[key];
    }
  }
  return next;
}

function validationForEditor(value = {}) {
  const next = Object.assign({}, value);
  if (next.errorMessage && !next.requiredMessage && next.required) next.requiredMessage = next.errorMessage;
  const existing = Array.isArray(next.rules) ? next.rules : [];
  const usedIds = new Set(existing.map(rule => rule.id).filter(Boolean));
  const fallbackId = suffix => {
    let id = `legacy-rule-${suffix}`;
    while (usedIds.has(id)) id += '-';
    usedIds.add(id);
    return id;
  };
  next.rules = existing.map((rule, index) => Object.assign(canonicalizeValidationRule(rule), {
    id: rule.id || fallbackId(index),
    type: rule.type || rule.kind || 'predicate',
    trigger: Array.isArray(rule.trigger) && rule.trigger.length
      ? rule.trigger.slice() : [typeof rule.trigger === 'string' && rule.trigger ? rule.trigger : 'submit'],
    severity: rule.severity || 'error',
    block: typeof rule.block === 'boolean' ? rule.block : rule.severity !== 'warn',
    message: rule.message || { en: '', fr: '' },
  }));
  if (next.pattern && !next.rules.some(rule => rule.type === 'pattern' && rule.pattern === next.pattern)) {
    next.rules.push(Object.assign({ id: fallbackId('pattern'), type: 'pattern', trigger: ['submit'], severity: 'error', block: true,
      message: { en: 'Invalid format', fr: 'Format invalide' }, pattern: next.pattern }, next.flags ? { flags: next.flags } : {}));
    delete next.pattern;
  }
  if (next.minLength && !next.rules.some(rule => rule.type === 'length' && rule.minLength === next.minLength)) {
    next.rules.push({ id: fallbackId('length'), type: 'length', trigger: ['submit'], severity: 'error', block: true,
      message: { en: `Minimum length is ${next.minLength}`, fr: `Longueur minimale ${next.minLength}` }, minLength: next.minLength });
    delete next.minLength;
  }
  return next;
}

module.exports = { canonicalizeValidationRule, validationForEditor };
